<template>
  <div class="pm200">
    <img src="../assets/img/banner.jpg" class="banner w100 cz" />
    <div>
      <div class="kjnjsfoer pd pt20">
        <div class="traveldate">
          <p class="fz16 z3">参观日期</p>
          <div
            class="explain-tips"
            v-if="options.groupTqBookDays > 0"
          >
            <van-icon name="info-o" />
            <span>须提前{{ options.groupTqBookDays }}天预约</span>
          </div>
        </div>
        <div class="row">
          <div
            class="kjmmjknmxer cen mr15"
            v-for="(date, idx) in options.dates"
            :key="date.date"
            :class="{
              act: orderInput.travelDate === date.date,
              disabled: date.disable,
            }"
            @click="dateChanged(idx)"
          >
            <p class="fz12 z3 dfgdt">{{ date.text.substr(0, 2) }}</p>
            <div class="cen btm zts fz16 pt10" style="font-size: 14px">
              {{ date.disable ? "不可订" : date.text.substr(2) }}
            </div>
          </div>
          <div class="col">
            <div class="kjmmjknmxer cen mr15 w100" @click="selectMoreDate">
              <p class="fz12 z3 dfgdt">更多</p>
              <div class="cen btm zts fz16 pt5">
                <i class="f_i gengdder"></i>
              </div>
            </div>
          </div>
        </div>
        <p class="mt15 fz16">
          参观区域
          <span class="z9 fz12" v-if="!addTicketTypeIds">
            (选择参观区域再选择入馆时段)</span
          >
        </p>
        <van-grid
          v-if="grounds[0]"
          :border="false"
          :column-num="2"
          style="margin-right: -10px"
        >
          <van-grid-item
            v-for="ground in grounds[0].children"
            :key="ground.value"
            :name="ground.value"
          >
            <div
              class="row fgdrtwer"
              :class="[
                ground.disabled || wxLastBookTime ? 'acb' : '',
                orderInput.groundId == ground.value ? 'act' : '',
              ]"
              @click="groundChange(ground)"
            >
              <div class="kmmxeert">
                <i class="f_i gounmxer" v-if="!ground.disabled"></i>
                <div v-else class="kjnmkxerse">闭<br />馆</div>
              </div>
              <div class="col pl5 pr5 z3 fz14 kmmxeert2">
                {{ ground.displayText }}
              </div>
            </div>
          </van-grid-item>
        </van-grid>
        <van-row>
          <div v-if="wxLastBookTime" class="panel-content">
            <div class="content-text2">
              超过今天最晚预约时间 {{ wxLastBookTime }}
            </div>
          </div>
        </van-row>
      </div>
      <div class="pd mt10">
        <p class="mt10 fz16">
          入馆时段
          <span class="z9 fz12"> (在该时段入场参观)</span>
        </p>
        <van-grid
          v-if="!wxLastBookTime && orderInput.groundId && changCis[0]"
          :border="false"
          :column-num="2"
          style="margin-right: -10px"
        >
          <van-grid-item
            v-for="changCi in changCis[0].children"
            :key="changCi.value"
            :name="changCi.value"
          >
            <div
              class="fgdrtwerab"
              :class="[orderInput.changCiId == changCi.value ? 'act' : '']"
              @click="changCiChange(changCi)"
            >
              <p class="fz17 z6">{{ changCi.text }}</p>
              <p class="zts fz12">{{ "(余票:" + changCi.surplusNum + ")" }}</p>
            </div>
          </van-grid-item>
        </van-grid>
        <div
          v-if="!wxLastBookTime && !orderInput.groundId"
          class="panel-content"
        >
          <div class="content-text2">请先选择参观区域</div>
        </div>
      </div>
      <!-- <div class="pd mt10" v-if="showExplain"> -->
      <div class="pd mt10">
        <p class="fz16 pm10">
          公益讲解场次
          <!-- <span class="fz12 red"> (每场次{{ options.groupExplainMinQuantity }}人起约，{{ options.groupExplainMaxQuantity }}人约满)</span> -->
        </p>
        <!-- <van-cell-group class>
          <van-cell title="需要讲解" class="field-cell left">
            <div class="explain">
              <van-switch
                v-model="orderInput.needExplain"
                size="18px"
                class="group-order-switch"
                active-color="#845F56"
              />
              <div
                class="explain-tips"
                v-if="options.groupExplainAdvanceDays > 0"
              >
                <van-icon name="info-o" />
                <span>须提前{{ options.groupExplainAdvanceDays }}天预约</span>
              </div>
            </div>
          </van-cell>
        </van-cell-group> -->        
        <div
            class="explain-tips"
            v-if="options.groupExplainAdvanceDays > 0"
          >
          <van-icon name="info-o" />
          <span>须提前{{ options.groupExplainAdvanceDays }}天预约</span>
        </div>
        <div class="" v-if="explainers && explainers.length > 0">
          <div v-for="(explainer, idx) in explainers" :key="idx">
            <div v-if="explainer.children.length > 0">
              <p class="pl5 fz12 z9 pt10">请选择{{ explainer.text }}讲解时间</p>
              <van-grid
                :border="false"
                :column-num="2"
              >
                <van-grid-item
                  class="fgdrtwerab"
                  :class="[child.selected ? 'act' : '']"          
                  style="flex-basis: calc(50% - 10px); margin-left: 5px; margin-right: 5px;"
                  v-for="child in explainer.children"
                  :key="child.value"
                  @click="onSelectExplainerTimePoint(child, explainer.children)"
                >
                  <div>
                    <p class="fz17" :class="[child.disabled ? 'z9' : 'z6']">
                      <!-- {{ child.text.substr(0, 11) }} -->
                      {{ child.name }} 
                    </p>
                    <!-- <p class="zts fz12">{{child.text.substr(11)}}</p> -->
                    <p class="fz12" :class="[child.disabled ? 'z9' : 'zts']">
                      ({{ changCiText(child) }})
                    </p>
                  </div>
                </van-grid-item>
              </van-grid>

              <!-- <van-row gutter="10">
                <van-col
                  span="12"
                  v-for="child in explainer.children"
                  :key="child.value"
                  @click="onSelectExplainerTimePoint(child, explainer.children)"
                >
                  <div
                    class="fgdrtwerab"
                    :class="[child.selected ? 'act' : '']"
                  >
                    <p class="fz17" :class="[child.disabled ? 'z9' : 'z6']">
                      {{ child.name }} 
                    </p>
                    <p class="fz12" :class="[child.disabled ? 'z9' : 'zts']">
                      ({{ child.disabled ? "已约满" : "可预约" }})
                    </p>
                  </div>
                </van-col>
              </van-row> -->
            </div>
          </div>
        </div>
        <div class="" v-else>          
          <p class="fz14" style="color:#a9716d; padding: 10px;">
            当前无公益讲解
          </p>
        </div>
        
        <div v-if="explainers && explainers.length > 0"> 
          <div class="fz12 red" style="padding: 10px 16px;">
            <p>须知：1、公益讲解预约（由于场地条件限制，需要{{ options.groupExplainMinQuantity }}人起约，最多{{ options.groupExplainMaxQuantity }}人）</p>
            <p>　　　2、预约成功后，请务必在预约的讲解时间前10分钟到达展厅讲解咨询处，核验预约凭证(二维码)，超过15分钟未到本次预约作废，敬请合理安排出行时间。</p>
          </div>
        </div>
      </div>
      
      <!-- <div class="pd mt10" v-if="selectExplainer">    
        <date-field
          label="讲解时间"
          placeholder="选择时间"
          v-model="orderInput.arrivalTime"
          type="time"
          :min-hour="minHour"
          :max-hour="maxHour"
          :minValue="minValue"
          :maxValue="maxValue"
          :showMsg="selectExplainer"
          msg="讲解预约成功后，请于讲解时间30分钟内，到达讲解咨询处，超时将不能安排讲解。"
        />
      </div> -->
      <div class="mt10">
        <p class="mt15 fz16 pm10 pd">参观信息</p>
        <van-cell-group class="pd">
          <!-- <van-field label="单位名称" placeholder="请输入单位名称" clearable :rules="[{ required: true }]" /> -->
          <van-cell title="单位名称" class="field-cell">
            <span style="color: #323233;">{{ member.customerName }}</span>
          </van-cell>
        </van-cell-group>
      </div>
      <van-cell-group class="pd">
        <div class="pd pt10 row pm10">
          <p style="padding-right: 30px; font-size: 14px;color: #646566;">
            客源类型
          </p>
          <van-radio-group
            class="col fz14"
            v-model="keYuanTypeId"
            direction="horizontal"
          >
            
            <van-radio v-for="(item,idx) in keYuanTypes[0].children" :key="idx" checked-color="#A9716D" :name="item.value" >{{ item.text }}</van-radio>
            <!-- <van-radio checked-color="#A9716D" name="1">内宾</van-radio>
            <van-radio checked-color="#A9716D" name="2">外宾</van-radio>
            <van-radio checked-color="#A9716D" name="4">港澳台</van-radio>
            <van-radio checked-color="#A9716D" name="5">学生</van-radio> -->
          </van-radio-group>
        </div>
        <van-field v-if="keYuanTypeId == 5"
          label="学校"
          :maxlength="300"
          placeholder="请输入学校名称及年级"
          v-model="orderInput.receivingCustomer"
          clearable
        ></van-field>
        <!-- <van-cell title="客源地" class="field-cell">
          <van-row class="inline-cell">
            <van-col :span="showArea ? 12 : 24">
              <picker-field
                placeholder="必填，选择客源地"
                v-model="regionId"
                :list="regions"
                :is-link="!showArea"
              />
            </van-col>
            <van-col span="12" v-if="showArea">
              <picker-field placeholder="选择客源地" v-model="orderInput.areaId" :list="areas" />
            </van-col>
          </van-row>
        </van-cell> -->
      </van-cell-group>
      <div
        class="pd pt10 pm10"
        v-if="!member.realNameFlag || keYuanTypeId == 2 || keYuanTypeId == 4"
      >
        <div class="pd sdfsdtywer pm10">
          <div class="pt10 pm10 row fz14">
            年龄段
            <span class="zts fz12">{{
              "*每单最多" + groupOrderMaxQuantity + "人"
            }}</span>
            <p class="col tr z3">参观人数</p>
          </div>
          <div class="btm pt10">
            <div
              class="row pt5 pm5"
              v-for="(ageRange, index) in ageRanges"
              :key="index"
            >
              <p class="col fz12 z3">{{ ageRange.displayText }}</p>
              <van-stepper
                v-model="ageRange.personNum"
                :min="0"
                :max="groupOrderMaxQuantity"
                integer
              />
            </div>
          </div>
        </div>
      </div>
      <div class="pd pt10 pm10" v-else>
        <!-- <div class="pd sdfsdtywer pm10"> -->
        <div class="pd row mb5">
          <p
            class="col"
            style="line-height: 30px; font-size: 14px;color: #646566;"
          >
            参观人数
          </p>
          <van-stepper
            async-change
            :value="adultQuantity"
            :defaultValue="0"
            :min="groupOrderMinQuantity"
            :max="maxQuantity"
            @change="onAdultQuantityChange"            
            @blur="onAdultQuantityBlur"
            integer
            step="1"
            ref="stepper"
          />
        </div>
        <div class="tourist-tips">
          <van-icon name="info-o" />
          <span>
            {{ "*每单最多" + groupOrderMaxQuantity + "人" }}
          </span>
        </div>
        <div class="sdfsdtywer">
          <div v-for="(adult, index) in orderInput.adults" :key="index">
            <van-cell-group>
              <div class="jjnnjxer ml10 fz14 adult-index">
                {{ index + 1 }}
              </div>
              <div>
                <van-field
                  label="姓名"
                  ref="adultName"
                  class="adultName ml20"
                  maxlength="30"
                  placeholder="必填，输入证件上的姓名"
                  v-model="adult.name.value"
                  :error="adult.name.error"
                  clearable
                >
                  <!-- <template slot="label">
                      <span class="cz">姓名</span>
                    </template> -->
                </van-field>
                <van-field
                  clickable
                  label="证件号码"
                  ref="certNo"
                  class="certNo ml20"
                  maxlength="18"
                  placeholder="必填，请输入身份证号码"
                  v-model="adult.certNo.value"
                  :error="adult.certNo.error"
                  clearable
                  @focus="onCertNoFocus(index)"
                  @touchstart.native.stop="onShowNumberKeyboard(index)"
                />
                <!-- <van-cell
                    title="证件号码"
                    class="certNo ml20"
                    :value="adult.certNo.value || '必填，请输入身份证号码'"
                    :error="adult.certNo.error"
                    plain
                    type="primary"
                    @touchstart.native.stop="onShowNumberKeyboard(index)"
                    :value-class="adult.certNo.value ? 'z4' : ''"
                  >
                  </van-cell>  -->
              </div>
            </van-cell-group>
          </div>
        </div>
        <!-- </div> -->
      </div>
      <van-cell-group class="pd">
        <van-field
          label="带队人员"
          :maxlength="30"
          placeholder="输入带队人员姓名"
          v-model="orderInput.jidiaoName"
          clearable
        ></van-field>
        <van-cell title="参观人员名单" title-style="min-width:90px" center>
          <van-uploader
            v-model="fileList"
            preview-size="60"
            multiple
            max-count="3"
            :before-read="beforeRead"
            :after-read="afterRead"
          >
          </van-uploader>
        </van-cell>
        <van-field
          label="备注"
          :maxlength="300"
          placeholder="请输入内容"
          v-model="orderInput.memo"
          clearable
        ></van-field>
      </van-cell-group>

      <div class="pd bgff pt15">
        <div v-if="packingLotId">
          <p class="mt20 fz16 pm10">
            停车位信息
          </p>
          <!-- <van-cell-group class>
            <van-cell title="需要停车位" class="field-cell left">
              <div class="explain">
                <van-switch v-model="orderInput.needPackingLot" size="18px" class="group-order-switch" active-color="#845F56"/>
              </div>
            </van-cell>
          </van-cell-group>          
          <van-cell-group v-if="orderInput.needPackingLot && packingLotId">
            <van-cell
              title="车辆类型"
              :value="carTypeName || '请选择'"
              :value-class="orderInput.carTypeId ? 'z3' : ''"
            />
            <van-field
              label="车牌号码"
              placeholder="必填，请输入车牌号码"
              clearable
              maxlength="8"              
              :value="orderInput.licensePlateNumber"
              @input="onLicensePlateNumberInput"
            />
          </van-cell-group> -->
          <van-cell-group class>
            <van-cell title="需要停车位" class="field-cell left">
              <div class="explain">
                <van-switch
                  v-model="orderInput.needPackingLot"
                  size="18px"
                  class="group-order-switch"
                  active-color="#845F56"
                />
              </div>
            </van-cell>
          </van-cell-group>

          <div v-if="orderInput.needPackingLot && packingLotId">
            <div class="row">
              <p
                class="col mt10  mb10"
                style="padding-left:16px; font-size: 14px;color: #646566;"
              >
                车位数量
              </p>
              <van-stepper
                class="row mt5"
                async-change
                :value="licensePlateNumberQuantity"
                :defaultValue="1"
                :min="0"
                :max="maximumParkingSpacesForTeamBooking"
                @change="onLicensePlateNumberQuantity"
                integer
                disable-input
              />
            </div>
            <div class="tourist-tips">
              <van-icon name="info-o" />
              <span>
                小型车:余{{ carSpacingNum }}车位， 大客车:余{{
                  busSpacingNum
                }}车位
              </span>
            </div>
            <div class="sdfsdtywer">
              <van-cell-group
                v-for="(licensePlateNumber, index) in licensePlateNumbers"
                :key="index"
              >
                <div class="jjnnjxer ml10 fz14 adult-index">
                  {{ index + 1 }}
                </div>
                <div>
                  <van-cell
                    class="pl30"
                    title="车辆类型"
                    :value="licensePlateNumber.carTypeName || '请选择'"
                    :value-class="licensePlateNumber.carTypeId ? 'z3' : ''"
                    is-link
                    @click="onShowCarType(index)"
                  />
                  <!-- <van-field
                    class="pl30"
                    maxlength="8" 
                    placeholder="必填，请输入车牌号码"
                    v-model="licensePlateNumber.licensePlateNumber"
                    clearable
                  >
                    <template slot="label">
                      <span class="cz">车牌号码</span>
                    </template>
                  </van-field>   -->
                  <van-field
                    readonly
                    class="pl30"
                    maxlength="8"
                    placeholder="必填，请输入车牌号码"
                    :value="licensePlateNumber.licensePlateNumber"
                    @focus="cphClick(index)"
                  >
                    <template slot="label">
                      <span class="cz">车牌号码</span>
                    </template>
                  </van-field>
                </div>
              </van-cell-group>
            </div>
          </div>
        </div>
        <p class="mt15 fz16 pm10">联系人信息</p>
        <van-cell-group>
          <van-field
            label-class=""
            label="姓名"
            :maxlength="30"
            placeholder="必填，请输入联系人姓名"
            v-model="orderInput.contactName"
            clearable
          ></van-field>
          <van-field
            label="手机号码"
            :maxlength="11"
            placeholder="必填，请输入联系人手机号码"
            type="tel"
            v-model="orderInput.contactMobile"
            clearable
          ></van-field>
          <van-field
            clickable
            label="身份证号"
            class="contactCertNo"
            maxlength="18"
            placeholder="必填，请输入联系人身份证号"
            v-model="contactCertNo.value"
            :error="contactCertNo.error"
            clearable
            @focus="onContactCertNoFocus()"
            @touchstart.native.stop="onShowContactNumberKeyboard()"
          />
        </van-cell-group>
        <van-button type="primary" block class="mt20" @click="onTempSave"
          >临时保存（有效期1天）</van-button
        >
        <div class="pd pt10 pm10 fz14 checkbox">
          <van-checkbox
            shape="square"
            :value="checked"
            @click="onValidate"
            icon-size="16px"
            checked-color="#845F56"
          >
            请认真填写上述信息，填写内容需真实有效，如果填写信息有误，您个人需承担相应法律责任，请配合现场工作人员各项措施和要求。
          </van-checkbox>
          <bottom-button
            text="立即预约"
            :loading="loading"
            @click="onSubmit"
            :class="!checked ? 'sdrtter' : ''"
          ></bottom-button>
        </div>
      </div>
    </div>
    <div v-for="(adult, index) in orderInput.adults" :key="index">
      <van-number-keyboard
        safe-area-inset-bottom
        theme="custom"
        class=""
        :title="
          adult.certNo.value
            ? '身份证：' + adult.certNo.value
            : '请输入' +
              (adult.name.value ? adult.name.value + '的' : '') +
              '身份证号码'
        "
        v-model="adult.certNo.value"
        :show="showNumberKeyboards[index].show"
        :maxlength="18"
        extra-key="X"
        close-button-text="完成"
        @blur="onBlurNumberKeyboard(index)"
      />
    </div>
    <van-number-keyboard
      safe-area-inset-bottom
      theme="custom"
      class=""
      :title="
        contactCertNo.value
          ? '身份证：' + contactCertNo.value
          : '请输入' +
            (orderInput.contactName ? orderInput.contactName + '的' : '') +
            '身份证号码'
      "
      v-model="contactCertNo.value"
      :show="showContactNumberKeyboards"
      :maxlength="18"
      extra-key="X"
      close-button-text="完成"
      @blur="onBlurContactNumberKeyboard()"
    />
    <van-calendar
      v-model="showDateTimePicker"
      @confirm="confirmMoreDate"
      color="#A9716D"
      :min-date="minDate"
      :max-date="maxDate"
    />
    <van-action-sheet
      v-model="showCarType"
      :actions="carTypes"
      @select="onCarTypeSelecter"
    />
    <car-key-board
      v-model="showkeyboard"
      :plateNumber="cph"
      :idx="clickIndex"
      @confirmBtnFn="confirmBtnFn"
    />
  </div>
</template>

<script>
import DateSelector from "@/components/DateSelector.vue";
import DateField from "@/components/DateField.vue";
import BottomButton from "@/components/BottomButton.vue";
import PickerField from "@/components/PickerField.vue";
import CarKeyBoard from "@/components/CarKeyBoard.vue";
import moment from "moment";
import validate from "@/utils/validator.js";
import dateHelper from "@/utils/dateHelper.js";
import orderService from "@/services/orderService.js";
import { mapState } from "vuex";
import explainerService from "@/services/explainerService.js";
import commonService from "@/services/commonService.js";
import scenicService from "./../services/scenicService.js";
import IdcardField from "@/components/IdCardField.vue";
import Cookies from "js-cookie";
import Vue from "vue";

let defaultMinHour = 8;
let defaultArrivalTime = "";

function Tourist() {
  this.type = "团体";
  this.name = {
    value: "",
    error: false,
    errorMessage: "",
  };
  this.certTypeId = 5;
  this.certTypeName = "二代身份证";
  this.certNo = {
    value: "",
    error: false,
    errorMessage: "",
    placeholder: "请输入证件号码",
    label: "证件号码",
  };
  this.birthday = "";
}
function LicensePlateNumber() {
  this.licensePlateNumber = "";
  this.carTypeId = ""; //大客车
  this.carTypeName = "";
}

export default {
  components: {
    DateSelector,
    DateField,
    BottomButton,
    PickerField,
    CarKeyBoard,
    IdcardField,
  },
  props: {
    ticketTypeIds: {
      type: String,
    },
  },
  data() {
    return {
      cph: new Array(8),
      showkeyboard: false,
      clickIndex: 0,
      cookieOrderInput: {},
      hasCookieOrderInput: false,
      loading: false,
      loadingExplainer: false,
      minValue: "",
      maxValue: "",
      minHour: defaultMinHour,
      maxHour: 18,
      orderInput: {
        travelDate: "",
        personNum: 1,
        arrivalTime: defaultArrivalTime,
        needPackingLot: false,
        plateNumbers: [],
        carTypeId: "",
        // licensePlateNumber: "",
        needExplain: true,
        explainerTimeslotSchedulings: [],
        contactName: "",
        contactMobile: "",
        certTypeId: "",
        certTypeName: "",
        contactCertNo: "",
        keYuanTypeId: "",
        areaId: "",
        jidiaoName: "",
        memo: "",
        groundId: "",
        changCiId: "",
        adultQuantity: 0,
        adults: [],
        childrenQuantity: 0,
        children: [],
      },
      licensePlateNumberQuantity: 1,
      licensePlateNumbers: [{ licensePlateNumber: "", carTypeId: "" }],
      keYuanTypeId: "1",
      ageRanges: [],
      explainers: [],
      keYuanTypes:[{
          text: "客源类型",
          children: [],
        }],
      areaItems: [],
      regions: [],
      regionId: "",
      areas: [],
      options: {
        dates: [],
        maxBookDays: 30,
      },
      grounds: [],
      changCis: [],
      wxLastBookTime: "",
      showDateTimePicker: false,
      carSpacingNum: 0,
      busSpacingNum: 0,

      carTypes: [],
      showCarType: false,
      showCarTypeIndex: 0,
      carTypeName: "",
      checked: false,
      packingLotId: "",

      adultQuantity: 0,
      changing: false, // 防重入锁
      fixing: false,
      showNumberKeyboards: [],

      showContactNumberKeyboards: false,
      contactCertNo: {
        value: "",
        error: false,
        errorMessage: "",
        placeholder: "请输入证件号码",
        label: "证件号码",
      },
      fileList: [],
      maxQuantity: 300
    };
  },
  computed: {
    selectExplainer() {
      let result = false;
      if (this.explainers.length > 0) {
        this.explainers.forEach((element) => {
          element.children.forEach((child) => {
            if (child.selected) {              
              result = true;
            }
          });
        });
      }      
      return result;
    },
    showExplain() {
      if (this.explainers.length == 0) {
        return false;
      }
      if (this.explainers.filter((d) => !d.disabled).length == 0) {
        return false;
      }
      return true;
    },
    addTicketTypeIds() {
      return this.ticketTypeIds;
    },
    groupOrderMaxQuantity() {
      let maxQuantity = 300;
      if (
        this.options.groupOrderMaxQuantity > 0 &&
        this.options.groupOrderMaxQuantity < 300
      ) {
        maxQuantity = this.options.groupOrderMaxQuantity;
      }      
      if(this.selectExplainer){
        maxQuantity = Math.min(maxQuantity, this.options.groupExplainMaxQuantity);
      }
      return maxQuantity;
    },
    groupOrderMinQuantity() {
      if (
        this.selectExplainer &&
        this.options.groupExplainMinQuantity > 0 &&
        this.options.groupExplainMinQuantity <= this.groupOrderMaxQuantity
      ) {
        return this.options.groupExplainMinQuantity;
      }
      return 0;
    },
    changCiSurplus() {
      let changCi = this.changCis[0].children.find(
        (a) => a.value == this.orderInput.changCiId
      );
      if (changCi) {
        return changCi.surplusNum;
      }
      return 0;
    },
    maximumParkingSpacesForTeamBooking() {
      var spacingNum = this.busSpacingNum + this.carSpacingNum;
      var maximum = 10;
      if (
        this.options.maximumParkingSpacesForTeamBooking > 0 &&
        this.options.maximumParkingSpacesForTeamBooking <= 10
      ) {
        maximum = this.options.maximumParkingSpacesForTeamBooking;
      }
      return maximum > spacingNum ? spacingNum : maximum;
    },
    showArea() {
      return this.areas.length > 0 && this.areas[0].children.length > 0;
    },
    minDate() {
      let date = this.options.dates.filter((d) => !d.disable)[0];
      if (date) {
        return new Date(date.date);
      }
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    },
    maxDate() {
      const date = moment()
        .add(this.options.maxBookDays, "days")
        .toDate();
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },
    ...mapState({
      member: (state) => state.memberModule.member,
    }),
  },
  methods: {    
    changCiText(changci) {
      let text = changci.disabled ? (changci.quantity > 0 ? "已过期" : "已约满") : "可预约" ;
      return text;
    },
    confirmBtnFn(e) {
      this.licensePlateNumbers[e.idx].licensePlateNumber = e.plateNumber;
    },
    cphClick(i) {
      this.clickIndex = i;
      var tempcph = [];
      var PlateNumber = this.licensePlateNumbers[i].licensePlateNumber.split(
        ""
      );
      for (var j = 0; j < PlateNumber.length; j++) {
        if (j < 8) {
          tempcph.push(PlateNumber[j]);
        }
      }

      this.cph = tempcph;
      this.showkeyboard = true;
    },
    onLicensePlateNumberInput(val) {
      this.orderInput.licensePlateNumber = val
        .toUpperCase()
        .replace(/\s*/g, "");
    },
    beforeRead(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg" &&
        file.type !== "image/png"
      ) {
        this.$toast("请上传 jpg/jpeg/png 格式图片");
        return false;
      }
      // const maxSize = (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png') ? 500 * 1024 : 1000 * 1024;
      // if(file.size >= maxSize){
      //   this.$toast('文件大小不能超过 500kb');
      //   return false;
      // }
      return true;
    },
    isOverSize(file) {
      const maxSize =
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png"
          ? 500 * 1024
          : 1000 * 1024;
      return file.size >= maxSize;
    },
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      setTimeout(() => {
        // file.status = 'failed';
        // file.message = '上传失败';
        file.status = "done";
        file.message = "上传成功";
      }, 10000);
    },
    validDateChangCi() {
      let errorMsg = "";
      if (!this.hasCookieOrderInput) {
        if (!this.orderInput.groundId) {
          errorMsg += "请选择区域";
        } else if (!this.orderInput.changCiId) {
          errorMsg += "请选择入馆时段";
        }
      }
      return errorMsg;
    },
    validChangCiSurplus(quantity) {
      let errorMsg = "";
      let changCi = this.changCis[0].children.find(
        (a) => a.value == this.orderInput.changCiId
      );
      if (changCi) {
        if (changCi.surplusNum < quantity) {
          errorMsg += "剩余数量不足。";
        }
      }
      return errorMsg;
    },
    validParkingAreaSurplus(quantity) {
      let errorMsg = "";

      if (this.busSpacingNum + this.carSpacingNum < quantity) {
        errorMsg += "停车位不足。";
      }

      return errorMsg;
    },
    onAdultQuantityChange(quantity) {
      if (this.changing) {return;}
      this.changing = true;
      
      let next = quantity;
      let errorMsg = this.validDateChangCi();      
      if (!errorMsg) {
        errorMsg += this.validChangCiSurplus(quantity);
        if(errorMsg){
          next = parseInt(this.orderInput.adultQuantity, 10);
        }
        else{
          if (this.groupOrderMinQuantity > 0 && quantity < this.groupOrderMinQuantity) {
            if(this.selectExplainer){
              errorMsg += "公益讲解预约最少" + this.groupOrderMinQuantity + "人";
            }
            else{
              errorMsg += "每单最少" + this.groupOrderMinQuantity + "人";
            }
            next = this.groupOrderMinQuantity;
          }
          else if (quantity > this.groupOrderMaxQuantity) {
            if(this.selectExplainer){
              errorMsg += "公益讲解预约最多" + this.groupOrderMaxQuantity + "人";
            }
            else{
              errorMsg += "每单最多" + this.groupOrderMaxQuantity + "人";
            }
            next = this.groupOrderMaxQuantity;
          }
          else{
            next = quantity;
          }  
        }
      }
      else{
        next = 0;
      }
      

      if (errorMsg) {
        this.$toast(errorMsg);
      }
      
      this.adultQuantity = next;
      this.orderInput.adultQuantity = next;
      this.$nextTick(() => {       
        this.changing = false;
      });
    },
    onAdultQuantityBlur(e) {
      if (this.fixing) return;
      this.fixing = true;

      const inputEl = e.target;
      const raw = inputEl.value;
      const num = parseInt(raw, 10);

      let next = this.adultQuantity;
      if (!isNaN(num)) {
        let errorMsg = this.validDateChangCi();
        if (errorMsg) {
          next = 0;
        }
        else{
          errorMsg += this.validChangCiSurplus(num);
          if (errorMsg) {
            next = parseInt(this.orderInput.adultQuantity, 10);;
          }
          else{
            if( this.groupOrderMinQuantity > 0 && num < this.groupOrderMinQuantity){
              next = this.groupOrderMinQuantity;
            }
            else if(this.groupOrderMaxQuantity > 0 && num > this.groupOrderMaxQuantity){
              next = this.groupOrderMaxQuantity;
            }  
            else{
              next = num;
            }          
          }
        }
        
      }

      // 1. 先改数据
      this.adultQuantity = next;
      this.orderInput.adultQuantity = this.adultQuantity;
      this.maxQuantity =next;
      //2. 再强制覆盖 DOM（打断 stepper 的内部状态）
      this.$nextTick(() => {
        if (inputEl) {
          inputEl.value = next;
        }
        this.onAdultQuantityChange(next);
        this.fixing = false;
        this.maxQuantity =300;
      });

    },
    onLicensePlateNumberQuantity(event) {
      let errorMsg = this.validDateChangCi();
      let minNum = 0;
      if (!errorMsg) {
        if (event > this.maximumParkingSpacesForTeamBooking) {
          minNum = this.maximumParkingSpacesForTeamBooking;
        } else {
          minNum = event;
        }
        errorMsg += this.validParkingAreaSurplus(minNum);
      }

      if (errorMsg) {
        this.$toast(errorMsg);
      } else if (minNum <= 0) {
        this.orderInput.needPackingLot = false;
      } else {
        this.licensePlateNumberQuantity = minNum;
      }
      //this.licensePlateNumberQuantity = event;
    },
    onValidate() {
      if (!this.validateInput()) {
        this.checked = false;
        return;
      }
      this.checked = !this.checked;
    },
    onContactCertNoFocus() {
      if (this.showContactNumberKeyboards) {
        document.activeElement.blur();
      }
    },
    onBlurContactNumberKeyboard() {
      try {
        let certRules = [
          {
            rule: "required",
          },
        ];
        certRules.push({
          rule: "isIdCard",
        });
        let result = validate([
          {
            value: this.contactCertNo.value,
            name: this.orderInput.contactName + "证件号码",
            rules: certRules,
          },
        ]);
        Vue.set(this.contactCertNo, "error", !result.success);
        Vue.set(this.contactCertNo, "errorMessage", result.message);
        if (!result.success) {
          this.$toast(result.message);
        }
      } finally {
        this.showContactNumberKeyboards = false;
      }
    },
    onShowContactNumberKeyboard() {
      document.activeElement.blur();
      this.showContactNumberKeyboards = true;
    },
    onBlurNumberKeyboard(index) {
      try {
        let certRules = [
          {
            rule: "required",
          },
        ];
        certRules.push({
          rule: "isIdCard",
        });
        let result = validate([
          {
            value: this.orderInput.adults[index].certNo.value,
            name: this.orderInput.adults[index].name.value + "证件号码",
            rules: certRules,
          },
        ]);
        Vue.set(this.orderInput.adults[index].certNo, "error", !result.success);
        Vue.set(
          this.orderInput.adults[index].certNo,
          "errorMessage",
          result.message
        );
        if (!result.success) {
          this.$toast(result.message);
        }
      } finally {
        this.showNumberKeyboards[index].show = false;
      }
    },
    onCertNoFocus(index) {
      if (this.showNumberKeyboards[index].show) {
        document.activeElement.blur();
      }
    },
    onShowNumberKeyboard(val) {
      //this.$refs.certNo[val].$refs.input.blur();
      document.activeElement.blur();
      for (var i = 0; i < this.showNumberKeyboards.length; i++) {
        this.showNumberKeyboards[i].show = false;
      }
      // let top = 0;
      // let element = document.querySelectorAll(".certNo")[val];
      // while (element) {
      //   top += element.offsetTop;
      //   element = element.offsetParent;
      // }
      // window.scrollTo(0, top - 100);

      this.showNumberKeyboards[val].show = true;
    },
    onShowCarType(index) {
      this.showCarTypeIndex = index;
      this.showCarType = true;
    },
    onCarTypeSelecter(item) {
      if (item.num <= 0) {
        this.$toast("车位已满");
        return;
      }
      this.licensePlateNumbers[this.showCarTypeIndex].carTypeId = item.value;
      this.licensePlateNumbers[this.showCarTypeIndex].carTypeName = item.name;
      this.showCarType = false;
    },
    onSelectExplainerTimePoint(child, children) {
      if (child.disabled) {
        let text = this.changCiText(child);
        this.$toast(`${text}，请选其他场次`);
      } else {
        if(!child.selected){          
          children.map((a) => {
            a.selected = false;
          });
          child.selected = true;
          this.orderInput.arrivalTime = "";
          this.minValue = child.text.substr(0,5);
          this.maxValue = child.text.substr(6,5);
          this.minHour = Number(child.text.substr(0,2));
          this.maxHour = Number(child.text.substr(6,2));
        } else {
          children.map((a) => {
            a.selected = false;
          });
          this.minValue = "";
          this.maxValue = "";
          this.minHour = defaultMinHour;
          this.maxHour = 18;
        }        
      }
      let errorMsg = "";
      if ( this.groupOrderMinQuantity > 0 && this.orderInput.adultQuantity < this.groupOrderMinQuantity) {
        if(this.selectExplainer){
          errorMsg += "公益讲解预约最少" + this.groupOrderMinQuantity + "人";
        }
        else{
          errorMsg += "每单最少" + this.groupOrderMinQuantity + "人";
        }
        this.$toast(errorMsg);
        this.orderInput.adultQuantity = this.groupOrderMinQuantity;
        this.adultQuantity = this.groupOrderMinQuantity;
      }
      else if (this.orderInput.adultQuantity > this.groupOrderMaxQuantity) {
        if(this.selectExplainer){
          errorMsg += "公益讲解预约最多" + this.groupOrderMaxQuantity + "人";
        }
        else{
          errorMsg += "每单最多" + this.groupOrderMaxQuantity + "人";
        }
        this.$toast(errorMsg);
        this.orderInput.adultQuantity = this.groupOrderMaxQuantity;
        this.adultQuantity = this.groupOrderMaxQuantity;
      }
    },
    onSelecterseert(item) {
      this.keYuanTypeId = item.value;
      this.keYuanTypeName = item.name;
      this.keydfseet = false;
    },
    dateChanged(index) {
      let date = this.options.dates[index];
      if (date.disable) {
        return;
      }
      this.orderInput.travelDate = date.date;

      // this.$emit("input", this.orderInput.travelDate);
    },
    selectMoreDate() {
      this.showDateTimePicker = true;
    },
    confirmMoreDate(value) {
      this.showDateTimePicker = false;

      value = moment(value);
      this.orderInput.travelDate = value.format("YYYY-MM-DD");
      // this.$emit("input", this.orderInput.travelDate);
      if (
        this.options.dates.filter((d) => d.date == this.orderInput.travelDate)
          .length <= 0
      ) {
        this.options.dates[this.options.dates.length - 1] = {
          date: this.orderInput.travelDate,
          text: value.format("ddd") + value.format("MM-DD"),
          disable: false,
        };
      }
    },
    setTravelDate() {
      this.orderInput.needPackingLot = false;
      this.orderInput.carTypeId = "";
      this.orderInput.licensePlateNumber = "";
      this.carTypes = [];

      if (this.orderInput.travelDate == "") {
        this.orderInput.travelDate = this.options.dates.filter(
          (d) => !d.disable
        )[0].date;
      } else {
        var temp = this.orderInput.travelDate;
        if (this.options.dates.filter((d) => d.date == temp).length > 0) {
          this.orderInput.travelDate = this.options.dates.filter(
            (d) => d.date == temp
          )[0].date;
        } else {
          var value = moment(temp);
          this.options.dates[this.options.dates.length - 1] = {
            date: temp,
            text: value.format("MM-DD") + value.format("ddd"),
            disable: false,
          };
          this.orderInput.travelDate = this.options.dates[
            this.options.dates.length - 1
          ].date;
        }
      }
    },
    groundChange(event) {
      if (this.wxLastBookTime) return;
      this.orderInput.groundId = event.value;
      // this.orderInput.needExplain = false;
      this.orderInput.needPackingLot = false;
      this.orderInput.carTypeId = "";
      this.orderInput.licensePlateNumber = "";
      this.carTypes = [];
    },
    changCiChange(event) {
      if (event.surplusNum <= 0) {
        this.$toast("该时段没有余票，请选择其它时段");
        return;
      }
      if(event.disabled){
        this.$toast("该时段不可预订，请选择其它时段");
        return;
      }
      this.orderInput.changCiId = event.value;
      //停车场
      this.packingLotId = event.packingLotId;
      this.carSpacingNum = event.carSpacingNum;
      this.busSpacingNum = event.busSpacingNum;
      this.orderInput.needPackingLot = false;
      this.carTypeName = "";
      this.orderInput.carTypeId = "";
      this.orderInput.licensePlateNumber = "";
      this.carTypes = [];
      if (this.packingLotId) {
        if (this.carSpacingNum > 0) {
          //this.carTypes.push({ value: 1, name: "小型车 (剩余车位数:"+ this.carSpacingNum+")", num:this.carSpacingNum });
          this.carTypes.push({
            value: 1,
            name: "小型车",
            num: this.carSpacingNum,
          });
        }
        if (this.busSpacingNum > 0) {
          //this.carTypes.push({ value: 2, name: "大客车 (剩余车位数:"+ this.busSpacingNum+")", num:this.busSpacingNum });
          this.carTypes.push({
            value: 2,
            name: "大客车",
            num: this.busSpacingNum,
          });
        }
        // this.carTypes = [
        //   { value: 1, name: "小型车 (剩余车位数:"+ this.carSpacingNum+")", num:this.carSpacingNum },
        //   { value: 2, name: "大客车 (剩余车位数:"+ this.busSpacingNum+")", num:this.busSpacingNum },
        // ];
      }
    },
    async getChangCis(travelDate, groundId) {
      if (!travelDate || !groundId) {
        return;
      }

      if (dateHelper.validEqualDateNow(travelDate)) {
        this.wxLastBookTime = await scenicService.validExceedWxLastBookTime();
        if (this.wxLastBookTime) {
          return;
        }
      }

      this.orderInput.changCiId = "";
      //场次
      const changCis = await scenicService.getGroundChangCiItemsAsync({
        groupFlag: true,
        travelDate: travelDate,
        groundId: groundId,
      });

      this.changCis = [
        {
          text: "场次",
          children: changCis.map((c) => {
            return {
              value: c.changCiId,
              text: c.sTime + "-" + c.eTime,
              disabled: c.disabled,
              surplusNum: c.surplusNum <= 0 ? "0" : c.surplusNum,
              packingLotId: c.packingLotId,
              carSpacingNum: c.carSpacingNum,
              busSpacingNum: c.busSpacingNum,
            };
          }),
        },
      ];

      //讲解
      try {
        this.loadingExplainer = true;
        this.explainers = await explainerService.getSchedulingsAsync({
          Date: travelDate,
          TicketTypeId: groundId,
        });
        if(this.explainers && this.explainers.length > 0){
          this.orderInput.needExplain = true; 
        } else {
          this.orderInput.needExplain = false; 
        }
      } finally {
        this.loadingExplainer = false;
      }
    },

    async getGrounds(travelDate) {
      if (!travelDate) {
        return;
      }
      this.wxLastBookTime = "";
      this.orderInput.groundId = "";
      var ticketTypeIds =
        this.ticketTypeIds == "0" ? [] : this.ticketTypeIds.split(",");

      var grounds = await scenicService.getGroundDtosAsync({
        travelDate: travelDate,
      });

      if (ticketTypeIds && ticketTypeIds.length > 0) {
        this.grounds = [];
        for (var i = 0; i < ticketTypeIds.length; i++) {
          for (var j = 0; j < grounds.length; j++) {
            if (
              grounds[j].value == ticketTypeIds[i] &&
              this.grounds.length == 0
            ) {
              this.grounds = [
                {
                  text: "区域",
                  children: [grounds[j]],
                },
              ];
            }

            if (grounds[j].value == ticketTypeIds[i] && !grounds[j].disabled) {
              this.grounds = [
                {
                  text: "区域",
                  children: [grounds[j]],
                },
              ];
              this.orderInput.groundId = ticketTypeIds[i];
              return;
            }
          }
        }
      } else {
        this.grounds = [
          {
            text: "区域",
            children: grounds,
          },
        ];
      }
    },
    async getTouristOriginTree(){
      let treeNode = await commonService.getTouristOriginTreeAsync();
      let keYuanTypeItems = treeNode.nodes.map((item) => {
        return {
          value: item.value,
          text: item.displayText,
          disabled: item.disabled,
        };
      });
      
      this.keYuanTypes = [
        {
          text: "客源类型",
          children: keYuanTypeItems,
        },
      ];

      // this.areaItems = treeNode.nodes.map((keYuan) => {
      //   return {
      //     value: keYuan.value,
      //     children: keYuan.nodes.map((region) => {
      //       return {
      //         text: region.displayText,
      //         value: region.value,
      //         disabled: region.disabled,
      //         children: region.nodes.map((area) => {
      //           return {
      //             text: area.displayText,
      //             value: area.value,
      //             disabled: area.disabled,
      //           };
      //         }),
      //       };
      //     }),
      //   };
      // });

      //this.setRegions(keYuanTypeItems[0].value);
    
    },
    setRegions(keYuanTypeId) {
      this.regions = this.areaItems.filter((a) => a.value == keYuanTypeId);
    },
    validateInput() {
      if (!this.orderInput.groundId) {
        this.$toast("请选择区域");
        return false;
      }

      if (!this.orderInput.changCiId) {
        this.$toast("请选择入馆时段");
        return false;
      }
      // if(this.orderInput.needExplain && !this.selectExplainer){
      //   this.$toast("请选择公益讲解场次");
      //   return false;
      // }
      if(this.selectExplainer){
        let arrivalTime = "";
        this.orderInput.arrivalTime = "";
        if (this.explainers.length > 0) {
          this.explainers.forEach((element) => {
            element.children.forEach((child) => {
              if (child.selected) {
                if(arrivalTime){
                  if(arrivalTime > child.beginTime){
                    arrivalTime = child.beginTime;
                  }
                }else{
                  arrivalTime = child.beginTime;
                }
              }
            });
          });
        }      
        this.orderInput.arrivalTime = arrivalTime;
      }
      
      if(this.selectExplainer && !this.orderInput.arrivalTime){
        this.$toast("请选择讲解时间");
        return false;
      }
      if(this.keYuanTypeId == 5 && !this.orderInput.receivingCustomer){
        this.$toast("请输入学校名称");
        return false;
      }
      if (
        !this.member.realNameFlag ||
        this.keYuanTypeId == 2 ||
        this.keYuanTypeId == 4
      ) {
        let selectedAgeRanges = this.ageRanges.filter((a) => a.personNum > 0);
        if (selectedAgeRanges.length <= 0) {
          this.$toast("请输入参观人数");
          return false;
        }
        this.orderInput.personNum = selectedAgeRanges
          .map((a) => a.personNum)
          .reduce((f, s) => s + f);
        if (this.orderInput.needExplain && this.selectExplainer && this.options.groupExplainMinQuantity > 0 && this.orderInput.personNum < this.options.groupExplainMinQuantity) { 
          this.$toast(`公益讲解预约最少${this.options.groupExplainMinQuantity}人`);
            return false;
          }
        if (this.orderInput.needExplain && this.selectExplainer && this.options.groupExplainMaxQuantity > 0 && this.options.groupExplainMaxQuantity < this.orderInput.personNum) {
          this.$toast(`公益讲解预约最多${this.options.groupExplainMaxQuantity}人`);
          return false;
        }
        if (this.orderInput.personNum > this.groupOrderMaxQuantity) {
          this.$toast(`每单最多${this.groupOrderMaxQuantity}人`);
          return false;
        }
        this.orderInput.ageRanges = selectedAgeRanges.map((a) => {
          return { ageRangeId: a.value, personNum: a.personNum };
        });
      } else {
        if (this.orderInput.adults.length <= 0) {
          this.$toast("请新增参观人数");
          return false;
        }

        for (let i = 0; i < this.orderInput.adults.length; i++) {
          let adult = this.orderInput.adults[i];
          let result = validate([
            {
              value: adult.name.value,
              name: "姓名",
              rules: [
                {
                  rule: "required",
                },
              ],
            },
          ]);
          Vue.set(adult.name, "error", !result.success);
          Vue.set(adult.name, "errorMessage", result.message);
          if (!result.success) {
            this.$refs.adultName[i].$refs.input.focus();
            this.$toast(result.message);
            return false;
          }

          let certRules = [
            {
              rule: "required",
            },
          ];
          if (adult.certTypeId == 5) {
            certRules.push({
              rule: "isIdCard",
            });
          }
          result = validate([
            {
              value: adult.certNo.value,
              name: adult.name.value + "证件号码",
              rules: certRules,
            },
          ]);
          Vue.set(adult.certNo, "error", !result.success);
          Vue.set(adult.certNo, "errorMessage", result.message);
          if (!result.success) {
            this.$toast(result.message);
            return false;
          }

          var adults = this.orderInput.adults.filter(function(elem) {
            return elem.certNo.value == adult.certNo.value;
          });
          if (adults.length > 1) {
            this.$toast(
              adults[0].name.value +
                "和" +
                adults[1].name.value +
                "的证件号码重复"
            );
            return false;
          }
        }

        let tourists = this.orderInput.adults.concat(this.orderInput.children);

        tourists = tourists.map((t) => {
          return {
            type: t.type,
            name: t.name.value,
            certTypeId: t.certTypeId,
            certNo: t.certNo.value,
            birthday: t.birthday,
          };
        });

        this.orderInput.tourists = tourists;
        this.orderInput.personNum = this.orderInput.adultQuantity;
      }

      if (
        !this.member.realNameFlag ||
        this.keYuanTypeId == 2 ||
        this.keYuanTypeId == 4
      ) {
        if (!this.member.registAreaId) {
          this.$toast("预约失败：单位注册所在地未填写，请联系工作人员处理。");
          return false;
        }
      }
      if (this.keYuanTypeId == 2 || this.keYuanTypeId == 4) {
        this.orderInput.areaId = "";
      } else {
        this.orderInput.areaId = this.member.registAreaId;
      }
      this.orderInput.keYuanTypeId = this.keYuanTypeId;
      // if (!this.orderInput.areaId && this.regionId) {
      //   this.orderInput.areaId = this.regionId;
      // }
      let validateRules = [
        // {
        //   value: this.orderInput.keYuanTypeId,
        //   name: "客源类型",
        //   rules: [{ rule: "required" }],
        // },
        // {
        //   value: this.orderInput.areaId,
        //   name: "客源地",
        //   rules: [{ rule: "required" }],
        // },
        {
          value: this.orderInput.contactName,
          name: "姓名",
          rules: [{ rule: "required" }],
        },
        {
          value: this.orderInput.contactMobile,
          name: "手机号",
          rules: [{ rule: "required" }, { rule: "isMobile" }],
        },
      ];
      let result = validate(validateRules);
      if (!result.success) {
        this.$toast(result.message);
        return false;
      }

      // if(!this.member.realNameFlag || this.keYuanTypeId==2 || this.keYuanTypeId==4)
      // {
      this.orderInput.certTypeId = 5;
      this.orderInput.certTypeName = "二代身份证";
      let certRules = [
        {
          rule: "required",
        },
      ];
      if (this.orderInput.certTypeId == 5) {
        certRules.push({
          rule: "isIdCard",
        });
      }
      result = validate([
        {
          value: this.contactCertNo.value,
          name: "联系人身份证号码",
          rules: certRules,
        },
      ]);
      Vue.set(this.contactCertNo, "error", !result.success);
      Vue.set(this.contactCertNo, "errorMessage", result.message);
      if (!result.success) {
        this.$toast(result.message);
        return false;
      }
      this.orderInput.contactCertNo = this.contactCertNo.value;
      // }

      if (this.orderInput.needPackingLot) {
        for (let i = 0; i < this.licensePlateNumbers.length; i++) {
          this.licensePlateNumbers[
            i
          ].licensePlateNumber = this.licensePlateNumbers[i].licensePlateNumber
            .toUpperCase()
            .replace(/\s*/g, "");
          let result = validate([
            {
              value: this.licensePlateNumbers[i].carTypeId,
              name: "车辆类型" + (i + 1) + " ",
              rules: [{ rule: "required" }],
            },
          ]);
          if (!result.success) {
            this.$toast(result.message);
            return false;
          }
          result = validate([
            {
              value: this.licensePlateNumbers[i].licensePlateNumber,
              name: "车牌号码" + (i + 1) + " ",
              rules: [{ rule: "required" }, { rule: "isPlateNumber" }],
            },
          ]);
          if (!result.success) {
            this.$toast(result.message);
            return false;
          }
        }
        this.orderInput.plateNumbers = this.licensePlateNumbers;
      }

      return true;
    },
    async onSubmit() {
      if (!this.validateInput()) {
        return;
      }

      this.orderInput.waiBinFlag =
        this.keYuanTypeId == 2 || this.keYuanTypeId == 4;
      this.orderInput.listOfVisitorsPhotoArray = [];
      if (this.fileList.length > 0) {
        for (var i = 0; i < this.fileList.length; i++) {
          if (this.fileList[i].status != "done") {
            this.orderInput.listOfVisitorsPhotoArray = [];
            this.$toast("图片正在上传中");
            return;
          }
          this.orderInput.listOfVisitorsPhotoArray.push(
            this.fileList[i].content
          );
        }
      }

      this.orderInput.explainerTimeslotSchedulings = [];
      if (this.explainers.length > 0) {
        this.explainers.forEach((element) => {
          element.children.forEach((child) => {
            if (child.selected) {
              this.orderInput.explainerTimeslotSchedulings.push({
                groundID: element.value,
                timeslotId: child.value,
              });
            }
          });
        });
      }

      try {
        this.loading = true;

        let response = await orderService.createGroupOrderAsync(
          this.orderInput
        );
        if (response.success) {
          Cookies.remove("orderInput");
          this.$router.replace({
            name: "orderinfo",
            params: {
              listNo: response.result,
              showNavbar: true,
            },
          });
        }
      } catch (err) {
        return;
      } finally {
        this.loading = false;
      }
    },
    onTempSave() {
      this.cookieOrderInput = this.orderInput;
      if (
        !this.member.realNameFlag ||
        this.keYuanTypeId == 2 ||
        this.keYuanTypeId == 4
      ) {
        let selectedAgeRanges = this.ageRanges.filter((a) => a.personNum > 0);
        if (selectedAgeRanges.length > 0) {
          this.cookieOrderInput.personNum = selectedAgeRanges
            .map((a) => a.personNum)
            .reduce((f, s) => s + f);
          this.cookieOrderInput.ageRanges = selectedAgeRanges.map((a) => {
            return { ageRangeId: a.value, personNum: a.personNum };
          });
        }
      } else {
        if (this.cookieOrderInput.adults.length > 0) {
          let tourists = this.cookieOrderInput.adults.concat(
            this.cookieOrderInput.children
          );
          tourists = tourists.map((t) => {
            return {
              type: t.type,
              name: t.name.value,
              certTypeId: t.certTypeId,
              certNo: t.certNo.value,
              birthday: t.birthday,
            };
          });
          this.cookieOrderInput.tourists = tourists;
          this.cookieOrderInput.personNum = this.cookieOrderInput.adultQuantity;
        }
      }

      if (this.keYuanTypeId == 2 || this.keYuanTypeId == 4) {
        this.cookieOrderInput.keYuanTypeId = this.keYuanTypeId;
        this.cookieOrderInput.areaId = "";
      } else {
        this.cookieOrderInput.areaId = this.member.registAreaId;
        this.cookieOrderInput.keYuanTypeId = 1;
      }

      this.cookieOrderInput.certTypeId = 5;
      this.cookieOrderInput.certTypeName = "二代身份证";
      this.cookieOrderInput.contactCertNo = this.contactCertNo.value;

      if (this.cookieOrderInput.needPackingLot) {
        this.cookieOrderInput.plateNumbers = this.licensePlateNumbers;
      }

      this.cookieOrderInput.explainerTimeslotSchedulings = [];
      if (this.explainers.length > 0) {
        this.explainers.forEach((element) => {
          element.children.forEach((child) => {
            if (child.selected) {
              this.cookieOrderInput.explainerTimeslotSchedulings.push({
                groundID: element.value,
                timeslotId: child.value,
              });
            }
          });
        });
      }
      Cookies.set("orderInput", this.cookieOrderInput, { expires: 1 });
      this.$toast("保存临时数据成功，有效期1天。");

      // // Create a cookie, valid across the entire site:
      // Cookies.set('name', 'value');

      // // Create a cookie that expires 7 days from now, valid across the entire site:
      // Cookies.set('name', 'value', { expires: 7 });

      // // Create an expiring cookie, valid to the path of the current page:
      // Cookies.set('name', 'value', { expires: 7, path: '' });

      // // Read cookie:
      // Cookies.get('name'); // => 'value'
      // Cookies.get('nothing'); // => undefined

      // // Read all visible cookies:
      // Cookies.get(); // => { name: 'value' }

      // // Delete cookie:
      // Cookies.remove('name');

      // // Delete a cookie valid to the path of the current page:
      // Cookies.set('name', 'value', { path: '' });
      // Cookies.remove('name'); // fail!
      // Cookies.remove('name', { path: '' }); // removed!

      // 跟一般使用不同的是，从Cookie中取出的时候，要从字符串转换成json格式：

      // const user = {
      //   name: 'lia',
      //   age: 18
      // }
      // Cookies.set('user', user)
      // const liaUser = JSON.parse(Cookies.get('user'))
    },
    initTime() {
      let now = moment();
      this.minHour = now.hour() > this.maxHour ? this.maxHour : now.hour();
      //this.orderInput.arrivalTime = this.minHour+":"+now.format("mm");
    },
  },
  watch: {
    licensePlateNumberQuantity: function(newVal, oldVal) {
      try {
        //this.loading = true;
        let diff = newVal - oldVal;
        if (diff > 0) {
          for (let i = 0; i < diff; i++) {
            let licensePlateNumber = new LicensePlateNumber();
            this.licensePlateNumbers.push(licensePlateNumber);
          }
        } else {
          if (this.licensePlateNumbers.length + diff > 0) {
            this.licensePlateNumbers.length += diff;
          } else {
            this.licensePlateNumbers.length = 0;
          }
        }
      } finally {
        //this.loading = false;
      }
    },
    "orderInput.adultQuantity": function(newVal, oldVal) {
      try {
        this.loading = true;
        let diff = newVal - oldVal;
        if (diff > 0) {
          for (let i = 0; i < diff; i++) {
            let adult = new Tourist();
            adult.type = "团体";
            this.orderInput.adults.push(adult);
            this.showNumberKeyboards.push({ show: false });
          }
        } else {
          if (this.orderInput.adults.length + diff > 0) {
            this.orderInput.adults.length += diff;
            this.showNumberKeyboards.length += diff;
          } else {
            this.orderInput.adults.length = 0;
            this.showNumberKeyboards.length = 0;
          }
          // if (this.orderInput.childrenQuantity > this.maxChildrenQuantity) {
          //   this.orderInput.childrenQuantity = this.maxChildrenQuantity;
          // }
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.travelDate": function(newVal, oldVal) {
      try {
        this.loading = true;
        this.orderInput.groundId = "";
        this.grounds = [];
        this.changCis = [];
        this.explainers = [];
        this.orderInput.needPackingLot = false;
        this.packingLotId = "";
        this.orderInput.carTypeId = "";
        this.orderInput.licensePlateNumber = "";
        this.carTypes = [];
        if (this.orderInput.travelDate == moment().format("YYYY-MM-DD")) {
          this.initTime();
        } else {
          this.minHour = defaultMinHour;
          this.orderInput.arrivalTime = defaultArrivalTime;
        }
        if (oldVal) {
          this.getGrounds(this.orderInput.travelDate).then(function() {});
          this.getChangCis(
            this.orderInput.travelDate,
            this.orderInput.groundId
          ).then(function() {});
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.groundId": function(newVal) {
      try {
        this.loading = true;
        this.orderInput.changCiId = "";
        this.changCis = [];
        this.explainers = [];
        if (newVal) {
          this.getChangCis(
            this.orderInput.travelDate,
            this.orderInput.groundId
          ).then(function() {});

          if ((this.member.customerId, this.orderInput.travelDate)) {
            orderService
              .getDailyOrderSurplusQuantityForCustomerAsync(
                this.member.customerId,
                this.orderInput.travelDate,
                this.orderInput.groundId
              )
              .then((surplusQuantity) => {
                if (surplusQuantity <= 0) {
                  this.$dialog.alert({
                    message: `${this.orderInput.travelDate} 已达的团体订单场馆预约上限，请选择其它日期或场馆！`,
                  });
                }
              });
          }
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.needPackingLot": function(val) {
      try {
        this.loading = true;
        if (!val) {
          this.orderInput.carTypeId = "";
          this.carTypeName = "";
          this.orderInput.licensePlateNumber = "";
        } else {
          if (!this.orderInput.groundId) {
            this.orderInput.needPackingLot = false;
            this.orderInput.carTypeId = "";
            this.carTypeName = "";
            this.$toast("请选择区域");
            return;
          }
          if (!this.orderInput.changCiId) {
            this.orderInput.needPackingLot = false;
            this.orderInput.carTypeId = "";
            this.carTypeName = "";
            this.$toast("请选择入馆时段");
            return;
          }
          if (!this.packingLotId) {
            this.orderInput.needPackingLot = false;
            this.orderInput.carTypeId = "";
            this.carTypeName = "";
            this.$toast("该区域没有停车场");
            return;
          }
          if (this.carTypes.length > 0) {
            var tempCarTypes = [];
            var num = 0;
            this.carTypes.forEach((item) => {
              if (item.num > 0) {
                tempCarTypes.push({
                  value: item.value,
                  name: item.name,
                  num: item.num,
                });
                num += item.num;
              }
            });
            this.carTypes = tempCarTypes;
            if (num <= 0) {
              this.orderInput.needPackingLot = false;
              this.orderInput.carTypeId = "";
              this.carTypeName = "";
              this.$toast("停车位不足");
              return;
            }
            // this.orderInput.carTypeId = this.carTypes[0].value;
            // this.carTypeName = this.carTypes[0].name;
          } else {
            this.orderInput.needPackingLot = false;
            this.$toast("停车位不足");
            return;
          }
        }
      } finally {
        this.loading = false;
      }
    },
    // "orderInput.needExplain": async function(val) {
    //   try {
    //     this.loading = true;
    //     if (!val) {
    //       this.orderInput.arrivalTime = "";
    //       if (this.explainers.length > 0) {
    //         this.explainers.forEach((element) => {
    //           element.children.map((a) => {
    //             a.selected = false;
    //           });
    //         });
    //       }
    //     } else {
    //       if (!this.orderInput.groundId) {
    //         this.orderInput.needExplain = false;
    //         this.$toast("请选择区域");
    //         return;
    //       }
    //       if (!this.orderInput.changCiId) {
    //         this.orderInput.needExplain = false;
    //         this.$toast("请选择入馆时段");
    //         return;
    //       }
    //       if (this.explainers.length == 0) {
    //         this.orderInput.needExplain = false;
    //         //this.$toast("须提前"+this.options.groupExplainAdvanceDays+"天预约");
    //         this.$toast("暂无公益讲解场次");
    //         return;
    //       }
    //       if (this.explainers.filter((d) => !d.disabled).length == 0) {
    //         this.orderInput.needExplain = false;
    //         this.$toast("暂无公益讲解场次");
    //         return;
    //       }
    //     }
    //     // this.options = await orderService.getOrderOptionsAsync(true, val);
    //     // this.setTravelDate();
    //   } finally {
    //     this.loading = false;
    //   }
    // },

    // "keYuanTypeId": function (val) {
    //   try {
    //     this.loading = true;
    //     this.regionId = "";
    //     if (val == "") {
    //       this.regions = [
    //         {
    //           text: "",
    //           children: [],
    //         },
    //       ];
    //     } else {
    //       this.setRegions(val);
    //     }
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    regionId: function(val) {
      try {
        this.loading = true;
        this.orderInput.areaId = "";
        if (val == "") {
          this.areas = [
            {
              text: "",
              children: [],
            },
          ];
        } else {
          this.areas = this.regions[0].children.filter((r) => r.value == val);
        }
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    if (!this.member.isCustomerLogin) {
      this.$router.replace({
        name: "grouplogin",
        params: {
          shouldBind: "0",
          nextPath: "creategrouporder",
          ticketTypeIds: this.ticketTypeIds,
        },
      });
    }

    if (Cookies.get("orderInput")) {
      this.hasCookieOrderInput = true;
    }
    if (this.hasCookieOrderInput) {
      this.cookieOrderInput = JSON.parse(Cookies.get("orderInput"));
      //停车位数量
      this.licensePlateNumberQuantity = this.cookieOrderInput.plateNumbers.length;
      //参观人数
      this.orderInput.adultQuantity = this.cookieOrderInput.adultQuantity;
      this.adultQuantity = this.cookieOrderInput.adultQuantity;
    }
    this.options = await orderService.getOrderOptionsAsync(true, false);
    this.initTime();
    commonService.getAgeRangeComboboxItemsAsync().then((items) => {
      this.ageRanges = items.map((item) => {
        return {
          value: item.value,
          displayText: item.displayText,
          personNum: 0,
        };
      });
      //年龄段
      if (
        this.hasCookieOrderInput &&
        this.cookieOrderInput.ageRanges &&
        this.cookieOrderInput.ageRanges.length > 0
      ) {
        for (var i = 0; i < this.cookieOrderInput.ageRanges.length; i++) {
          this.ageRanges.forEach((item) => {
            if (item.value == this.cookieOrderInput.ageRanges[i].ageRangeId) {
              item.personNum = this.cookieOrderInput.ageRanges[i].personNum;
            }
          });
        }
      }
    });

    if (this.hasCookieOrderInput) {
      this.orderInput.travelDate = this.cookieOrderInput.travelDate;
    } else {
      this.setTravelDate();
    }

    var jobGetGrounds = await this.getGrounds(this.orderInput.travelDate);
    var jobGetChangCis = await this.getChangCis(
      this.orderInput.travelDate,
      this.orderInput.groundId
    );
    var jobGetTouristOriginTree = await this.getTouristOriginTree();
    Promise.all([jobGetGrounds, jobGetChangCis, jobGetTouristOriginTree])
      .then(() => {
        this.loading = true;
        if (
          this.hasCookieOrderInput &&
          this.orderInput.groundId == this.cookieOrderInput.groundId
        ) {
          //入馆时段
          if (this.changCis && this.changCis[0].children) {
            this.changCis[0].children.forEach((changCi) => {
              if (changCi.value == this.cookieOrderInput.changCiId) {
                this.orderInput.changCiId = this.cookieOrderInput.changCiId;
                var event = changCi;
                if (event.surplusNum <= 0) {
                  this.$toast("该时段没有余票，请选择其它时段");
                  return;
                }

                //停车场
                this.packingLotId = event.packingLotId;
                this.carSpacingNum = event.carSpacingNum;
                this.busSpacingNum = event.busSpacingNum;
                this.orderInput.needPackingLot = false;
                this.carTypes = [];
                if (this.packingLotId) {
                  if (this.carSpacingNum > 0) {
                    this.carTypes.push({
                      value: 1,
                      name: "小型车",
                      num: this.carSpacingNum,
                    });
                  }
                  if (this.busSpacingNum > 0) {
                    this.carTypes.push({
                      value: 2,
                      name: "大客车",
                      num: this.busSpacingNum,
                    });
                  }
                }
                //停车位信息
                this.orderInput.needPackingLot = this.cookieOrderInput.needPackingLot;
                this.licensePlateNumbers = this.cookieOrderInput.plateNumbers;
              }
            });
          }
          this.orderInput.arrivalTime = this.cookieOrderInput.arrivalTime;
          this.orderInput.contactName = this.cookieOrderInput.contactName;
          this.orderInput.contactMobile = this.cookieOrderInput.contactMobile;
          this.orderInput.jidiaoName = this.cookieOrderInput.jidiaoName;
          this.orderInput.memo = this.cookieOrderInput.memo;
          //参观人信息
          this.orderInput.adults = this.cookieOrderInput.adults;

          //公益讲解场次
          // this.orderInput.needExplain = this.cookieOrderInput.needExplain; 
          if (this.cookieOrderInput.explainerTimeslotSchedulings.length > 0) {
            for (
              var j = 0;
              j < this.cookieOrderInput.explainerTimeslotSchedulings.length;
              j++
            ) {
              this.explainers.forEach((element) => {
                if (
                  element.value ==
                    this.cookieOrderInput.explainerTimeslotSchedulings[j]
                      .groundID &&
                  element.children
                ) {
                  element.children.forEach((child) => {
                    if (
                      child.value ==
                      this.cookieOrderInput.explainerTimeslotSchedulings[j]
                        .timeslotId
                    ) {
                      child.selected = true;
                    }
                  });
                }
              });
            }
          }
          //客源类型
          this.keYuanTypeId = this.cookieOrderInput.keYuanTypeId.toString();
          //联系人身份证号
          this.contactCertNo.value = this.cookieOrderInput.contactCertNo;
        }
      })
      .catch(() => {})
      .finally(() => {
        this.hasCookieOrderInput = false;
        this.loading = false;
      });

    // if (!this.member.registAreaId || !this.member.registAreaTypeId) {
    //     this.$toast("单位注册所在地未填写，请联系工作人员处理。");
    //   }

    

  },
  mounted() {},
  // beforeRouteLeave(to, from, next) {
  //   next();
  // },
};
</script>

<style lang="scss">
.van-grid-item__content {
  background-color: transparent;
}
.traveldate{
  display: flex;
  align-items: center;
  line-height: 24px;
}
.group-order {
  .van-hairline--top-bottom::after {
    border-width: 0;
  }
  .van-cell__value {
    text-align: left;
  }

  &-person {
    .van-cell {
      padding: 3px 15px;
    }

    .van-cell:not(:last-child)::after {
      border: none;
    }
  }

  &-tips {
    padding: 5px 10px;
    margin-top: 7px;
    margin-bottom: 10px;
    font-size: 12px;
    background-color: rgb(245, 249, 248);

    span {
      padding-left: 5px;
    }
  }

  &-switch {
    vertical-align: middle;
  }
}

.inline-cell {
  .van-cell {
    padding: 0;
  }

  .van-hairline--bottom::after {
    border-bottom-width: 0;
  }

  .van-cell:not(:last-child)::after {
    border-bottom-width: 0;
  }
}

.explain {
  display: flex;
  align-items: center;

  &-tips {
    margin-left: 10px;
    font-size: 12px;
    background-color: rgb(245, 249, 248);

    span {
      padding-left: 5px;
    }
  }
}
.pd {
  padding-left: 16px;
  padding-right: 16px;
}
.fz14 {
  font-size: 14px !important;
}
.van-cell {
  color: #646566;
}
.van-number-keyboard__title {
  font-size: 18px;
}
.van-key--blue {
  background-color: #845f56;
  color: #fff;
}
.adult-index {
  position: absolute;
  top: 14px;
  z-index: 100;
}
</style>
